import * as React from 'react'

import './Grid.scss'

type Props = {
    className?: string
    id?: string
}

class Grid extends React.Component<React.PropsWithChildren<Props>> {
    render() {
        const { className = '', children, id } = this.props

        return (
            <div className={`${className} container grid`} id={id}>
                {children}
            </div>
        )
    }
}

export default Grid
